import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MyNavbar from "./components/MyNavbar";
import ProtectedRoute from "./components/ProtectedRoute";
import ToastNotification from "./components/ToastNotification";
import Home from "./pages/Home";
import Login from "./pages/Login";
// Customer Imports
import Menu from "./pages/customer/Menu";
import Booking from "./pages/customer/Booking";
import Profile from "./pages/customer/Profile";
import History from "./pages/customer/History";
import MemberCard from "./pages/customer/MemberCard";
// Admin Imports
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
// Staff Imports
import StaffLayout from "./pages/staff/StaffLayout";
import StaffDashboard from "./pages/staff/StaffDashboard";

function App() {
  return (
    <Router>
      {/* Skip to Main Content Link (Accessibility) */}
      <a href="#main-content" className="skip-to-main">
        Chuyển đến nội dung chính
      </a>

      {/* Global Toast Notifications */}
      <ToastNotification />

      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />

        {/* Guest Routes (accessible without login) */}
        <Route
          path="/"
          element={
            <>
              <MyNavbar />
              <Home />
            </>
          }
        />
        <Route
          path="/menu"
          element={
            <>
              <MyNavbar />
              <Menu />
            </>
          }
        />

        {/* Customer Routes (requires customer login) */}
        <Route
          path="/booking"
          element={
            <ProtectedRoute allowedRoles={["customer", "admin"]}>
              <MyNavbar />
              <Booking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedRoles={["customer", "admin"]}>
              <MyNavbar />
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/history"
          element={
            <ProtectedRoute allowedRoles={["customer", "admin"]}>
              <MyNavbar />
              <History />
            </ProtectedRoute>
          }
        />
        <Route
          path="/member-card"
          element={
            <ProtectedRoute allowedRoles={["customer", "admin"]}>
              <MemberCard />
            </ProtectedRoute>
          }
        />

        {/* Admin Routes (requires admin role) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route
            path="users"
            element={
              <div className="p-4">
                <h3>Quản lý Users</h3>
              </div>
            }
          />
          <Route
            path="bookings"
            element={
              <div className="p-4">
                <h3>Quản lý Bookings</h3>
              </div>
            }
          />
          <Route
            path="menu"
            element={
              <div className="p-4">
                <h3>Quản lý Menu</h3>
              </div>
            }
          />
          <Route
            path="revenue"
            element={
              <div className="p-4">
                <h3>Báo cáo Doanh thu</h3>
              </div>
            }
          />
        </Route>

        {/* Staff Routes (requires staff role) */}
        <Route
          path="/staff"
          element={
            <ProtectedRoute allowedRoles={["staff", "admin"]}>
              <StaffLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<StaffDashboard />} />
          <Route
            path="tables"
            element={
              <div className="p-4">
                <h3>Quản lý Bàn (Check-in/Out)</h3>
              </div>
            }
          />
          <Route
            path="orders"
            element={
              <div className="p-4">
                <h3>Quản lý Đơn món (KDS)</h3>
              </div>
            }
          />
          <Route
            path="devices"
            element={
              <div className="p-4">
                <h3>Quản lý Thiết bị</h3>
              </div>
            }
          />
          <Route
            path="feedback"
            element={
              <div className="p-4">
                <h3>Hỗ trợ & Phản hồi</h3>
              </div>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
